import isValidAbn from 'is-valid-abn'

// ASIC check-digit algorithm: weight the first eight digits by 8..1, sum them,
// and the ninth digit must equal (10 - sum % 10) % 10.
const ACN_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 1]

export const isValidAcn = (value) => {
  if (!value) {
    return false
  }

  const digits = String(value).replace(/\s/g, '')

  if (!/^\d{9}$/.test(digits)) {
    return false
  }

  const sum = ACN_WEIGHTS.reduce(
    (total, weight, index) => total + weight * Number(digits[index]),
    0,
  )

  return (10 - (sum % 10)) % 10 === Number(digits[8])
}

export const isValidBusinessNumber = (value) =>
  isValidAbn(value) || isValidAcn(value)
